import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const useDeploymentsRoute = (): Route | string => {
	const { data: project } = useProjectContext();

	const routeName = project?.simplified ? 'software-deployments' : 'software-deployments-classic';

	return useRouteByName(routeName) ?? routeName;
};
